"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.System404 = void 0;
/* eslint-disable react/prefer-stateless-function */
// TODO make System404 a pure function
var react_1 = __importDefault(require("react"));
var react_helmet_1 = require("react-helmet");
var antd_1 = require("antd");
require("antd/lib/result/style");
var System404 = /** @class */ (function (_super) {
    __extends(System404, _super);
    function System404() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    System404.prototype.render = function () {
        return (react_1.default.createElement(antd_1.Result, { status: "404", title: "404", subTitle: "Sorry, the page you visited does not exist." },
            react_1.default.createElement(react_helmet_1.Helmet, { title: "Page 404" })));
    };
    return System404;
}(react_1.default.Component));
exports.System404 = System404;
// export default System404;
exports.default = {
    name: '404',
    routeProps: {
        path: '/404',
        component: System404,
    },
};
//# sourceMappingURL=index.js.map